import styled from 'styled-components';

export const Title = styled.h1`
	margin: 1rem 0 1rem 6rem;
	@media (max-width: 700px) {
		margin: 1rem;
	}
`;
